// initial state
import * as base from './base.js'
const baseName = '/admin/system/knowledge'
const typesName = '/admin/system/type'
const labeleName = '/admin/system/label'
const commentName = '/admin/system/message'

const knowledge = baseName + '/list'
const orderDelete = baseName + '/del'
const knowledgeClass = typesName + '/list'
const knowledgeTag = labeleName + '/list'
const knowledgeComment = commentName + '/list'
// const paymentRefund = paymentRefundName + '/lists'

const orderLatlngs = baseName + '/latlngs'

const obj = base.setBaseUrl('knowledge', baseName)
const obj1 = base.setBaseUrl('knowledgeClass', typesName)
const obj2 = base.setBaseUrl('knowledgeTag', labeleName)
const obj3 = base.setBaseUrl('knowledgeComment', commentName)

const a = Object.assign(obj,obj1,obj2,obj3, { knowledge, orderDelete,knowledgeClass,knowledgeTag,knowledgeComment})
export default a
